// extracted by mini-css-extract-plugin
export var modal = "_fc-0";